import { api, withFallback } from "./api";
import { REVIEW_SUMMARY, SAMPLE_REVIEWS } from "../data/reviews";

export const reviewService = {
  summary: () =>
    withFallback(() => api.get("/google-reviews"), {
      ...REVIEW_SUMMARY,
      reviews: SAMPLE_REVIEWS,
    }),
};
